import styled from '@emotion/styled';
import { colors, gridSize } from '@atlaskit/theme';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { token } from '@atlaskit/tokens';

const ReCaptchaContainer = styled.div`
  margin-top: ${gridSize()}px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const PolicyLink = styled.a`
  color: ${token('color.link', colors.B400)};

  &:hover {
    color: ${token('color.link', colors.B400)};
  }
`;

export const RecaptchaNotice = () => (
  <FormattedMessage
    id="signup.form.recaptcha.notice.xml"
    defaultMessage="This site is protected by reCAPTCHA and the Google <google-pp-link>Privacy Policy</google-pp-link> and <google-tos-link>Terms of Service</google-tos-link> apply."
    values={{
      'google-pp-link': chunks => (
        <PolicyLink
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noreferrer noopener">
          {chunks}
        </PolicyLink>
      ),
      'google-tos-link': chunks => (
        <PolicyLink
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noreferrer noopener">
          {chunks}
        </PolicyLink>
      ),
    }}
  />
);

export default ReCaptchaContainer;
